
function startPromptSearch (value) {
    let form = $('.js-search-form'),
        container = form.find('.fast-search__helper-container');

    form.addClass('loading');

    $.ajax({
        type: 'post',
        url: wc_add_to_cart_params.ajax_url,
        data: {
            action: 'ajax_search_prompt',
            search_request: value
        },
        success: function (response) {
            if(response.success){
                form.removeClass('loading');
                container.html(response.html);
            }
        },
    });
}

function disableSearchFocus(){
    $('.js-search-form').removeClass('focus');
    $('body').removeClass('js-search-active body-overflow');
    $('.overlay-bg, .menu-icon.active, #main-nav, body').removeClass('active');
}

function activateSearchFocus(){
    $('.js-search-form').addClass('focus');
    $('body').addClass('js-search-active');
    $('.overlay-bg, .menu-icon').addClass('active');
}

(function ($) {
    $(document).on('input', '.js-search-form .fast-search__input', function (e) {
        const value = $(this).val()
        const length = value.trim().length

        if (length >= 3) {
            startPromptSearch(value)
        }
    });

    $(document).on('focus', '.js-search-form .fast-search__input', function (){
        activateSearchFocus();
    });

    $('.fast-search__close-btn, .overlay-bg').on('click', function (){
        disableSearchFocus();

    });
})(jQuery);
